import { Link } from "react-router-dom";
import { Home, Compass } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "Seite nicht gefunden – Pirate Bowling Center Velburg",
    description: "Die gesuchte Seite existiert nicht. Zurück zur Startseite des Pirate Bowling Center Velburg.",
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-navy text-cream flex flex-col items-center justify-center px-6 py-20 relative overflow-hidden">
      <div className="hidden 2xl:block absolute top-1/3 left-1/4 w-80 h-80 rounded-full bg-gold/10 blur-[120px] pointer-events-none" />
      <div className="hidden 2xl:block absolute bottom-1/3 right-1/4 w-64 h-64 rounded-full bg-gold/8 blur-[100px] pointer-events-none" />

      <div className="relative z-10 text-center max-w-lg">
        <div className="skull-divider mb-6">
          <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">Auf hoher See verirrt</span>
        </div>

        <h1 className="font-unbounded text-7xl sm:text-8xl md:text-9xl font-black gold-gradient-text leading-none mb-4">
          404
        </h1>

        <p className="font-space-grotesk text-base md:text-lg text-cream/80 mb-3 leading-relaxed">
          Diese Seite existiert nicht oder wurde auf eine andere Insel verlegt.
        </p>
        <p className="font-inter text-sm text-cream/50 mb-10">
          Kein Grund zur Meuterei – zurück zum Hafen und neue Abenteuer planen.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="inline-flex items-center gap-3 btn-gold px-8 py-4 rounded-full text-sm"
            data-testid="notfound-home-btn"
          >
            <Home className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <a
            href="https://4bowl.de/pirate-bowling/online/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 btn-outline px-8 py-4 rounded-full text-sm"
            data-testid="notfound-reserve-btn"
          >
            <Compass className="w-4 h-4" />
            Bahn reservieren
          </a>
        </div>
      </div>
    </div>
  );
}
